import { Inject, Injectable } from '@angular/core';

export class CampaignUpdate {
	constructor(
		public id: number,
		public growth: number,
		public next_year_leads: number,
		public lead_cost: number,
	) {}
}
